import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Terminal, KeyRound } from "lucide-react";

export default function ResetPin() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pin, setPin] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pin.length !== 4 || !/^\d+$/.test(pin)) return toast.error("PIN must be 4 digits");
    if (pin !== confirm) return toast.error("PINs don't match");
    setLoading(true);
    try {
      await api.post("/auth/reset-pin", { token, pin });
      toast.success("PIN reset. Sign in with your new PIN.");
      navigate("/login");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed");
    } finally { setLoading(false); }
  };

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center px-6 text-fg" style={{ background: "var(--bg)" }}>
        <div className="max-w-md w-full text-center">
          <div className="font-display text-2xl text-live">Invalid link</div>
          <p className="mt-2 text-fg-muted font-mono text-sm">This reset link is missing a token. Request a new one.</p>
          <Link to="/forgot-pin" className="btn-primary mt-6 inline-flex">Request New Link</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-6 text-fg" style={{ background: "var(--bg)" }}>
      <div className="max-w-md w-full" data-testid="reset-pin-page">
        <Link to="/" className="flex items-center gap-2 mb-10">
          <Terminal size={18} className="text-amber"/>
          <div className="font-display text-xl text-amber">COYOTE/LIFE</div>
        </Link>
        <div className="label-xs text-amber">&gt; NEW_PIN</div>
        <h1 className="font-display text-4xl sm:text-5xl leading-none mt-2 flex items-center gap-3">
          <KeyRound size={30} strokeWidth={1.5} className="text-amber"/> Reset.
        </h1>
        <p className="mt-3 text-fg-muted font-mono text-sm">Pick a new 4-digit PIN. You&apos;ll use this to log in.</p>

        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <label className="label-xs mb-1 block">New PIN</label>
            <input type="password" maxLength={4} inputMode="numeric" className="input-term text-2xl tracking-[0.5em] text-center text-amber" value={pin} onChange={(e) => setPin(e.target.value.replace(/\D/g, ""))} required data-testid="reset-pin-input" />
          </div>
          <div>
            <label className="label-xs mb-1 block">Confirm</label>
            <input type="password" maxLength={4} inputMode="numeric" className="input-term text-2xl tracking-[0.5em] text-center text-amber" value={confirm} onChange={(e) => setConfirm(e.target.value.replace(/\D/g, ""))} required data-testid="reset-pin-confirm" />
          </div>
          <button type="submit" disabled={loading} data-testid="reset-submit-btn" className="btn-primary w-full">
            {loading ? "Resetting..." : "Reset PIN >"}
          </button>
        </form>
      </div>
    </div>
  );
}
